import { MessageContentProps } from "../types";
import { Content, FileContent, Icon, Filename } from "../styles";
import { useCurrentMeeting } from "../../../../contexts/currentMeeting";
import { IconButton, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatBytes, getIconFromMIME } from "../tools";
import LoadingIcon from "conference/components/svg-icons/LoadingIcon";
import ImagePreviewContent from "./ImagePreviewContent";
import UploadingLocalContent from "./UploadingLocalContent";
import { FileMessageContent } from "conference/components/meeting-page/room/types";

function parseContent(content: string): FileMessageContent {
    return JSON.parse(content);
}

const GenericFileMessageContent = ({ message }: MessageContentProps) => {
    const currentMeeting = useCurrentMeeting();

    const content = parseContent(message.content);

    if (currentMeeting.selfUri === message.sender && !content.file_url)
        return <UploadingLocalContent content={content} messageId={message.messageId} />;

    if (content.metadata?.mime_type.startsWith("image/") && content.preview_url)
        return <ImagePreviewContent content={content} />;

    return (
        <Content>
            <FileContent>
                <Icon>
                    <FontAwesomeIcon size="2x" icon={getIconFromMIME(content.metadata?.mime_type)} />
                </Icon>
                <Filename>
                    <Tooltip title={content.filename} arrow placement="top">
                        <div style={{ fontWeight: "bold" }}>{content.filename}</div>
                    </Tooltip>
                    <div style={{ fontSize: "0.8em" }}>{formatBytes(content.metadata.size)}</div>
                </Filename>
                {content.file_url ? (
                    <IconButton
                        href={`${window.chattoBaseUrl}${content.file_url}?filename=${encodeURIComponent(content.filename)}`}
                        target="_blank"
                        style={{ transform: "scale(0.9)" }}
                        size="large"
                    >
                        <FontAwesomeIcon icon="download" />
                    </IconButton>
                ) : (
                    <LoadingIcon style={{ maxHeight: 35, maxWidth: 35, marginRight: 6 }} color="default" />
                )}
            </FileContent>
        </Content>
    );
};

export default GenericFileMessageContent;
